import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ExecutionInfoResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetExecutionInfo = (
  id: number | string,
  {
    enabled = true,
    refetchInterval,
  }: { enabled?: boolean; refetchInterval: number | false }
) => {
  return useQuery<any, AxiosError<any>, ExecutionInfoResponse>(
    ["execution", id],
    () =>
      axiosClient
        .get<ExecutionInfoResponse>(`/execution/info/${id}`)
        .then(({ data }) => data),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled,
      refetchInterval,
    }
  );
};
